import {
  supportTrainingRequestSchema,
  type SupportTrainingRequest,
} from './SupportTrainingRequestSchema';

export const supportTrainingMessageInputSchema = supportTrainingRequestSchema;

export type SupportTrainingMessageInput = SupportTrainingRequest;
